import React from "react";
import ConnectedProductModalContent from "./ConnectedProductModalContent";
import { ModalStateProvider } from "./ModalStateContext";

const ProductModal = () => (
    <ModalStateProvider>
        <ConnectedProductModalContent />
    </ModalStateProvider>
);

export default ProductModal;
